/* eslint-disable @tencent/i18next/no-literal-string */
export const copyRightFont = [
    '日系可爱奶酪体',
    '化身孤岛的蓝鲸',
    '粗楷体两万字库',
    '森林麋鹿',
    '情之所钟唯有你',
    '潇湘行书',
    '肥肥胖胖充满希望',
    '你是我收藏的诗篇',
    '星际奶酪体',
    '雅士黑中粗',
    '造字工房薄荷海盐体',
    '造字工房芝士少女体',
    '方正仿宋简体',
    '方正隶书简体',
    '方正新楷体简体',
    '方正姚体简体',
    '方正仿宋_GBK',
    '方正黑体_GBK',
    '方正楷体_GBK',
    '方正隶书_GBK',
    '方正姚体_GBK',
    '方正兰亭黑_GBK',
    '方正书宋_GBK',
    '方正中等线_GBK',
    'Times New Roman',
    'Helvetica LT Pro',
    'MiSans',
    'Museo Slab 500',
    'Neo Sans',
    'Source Han Sans VF',
    'Source Han Serif VF',
    'Times NR MT Pro',
    'TsangerYunHei-W04',
    '撒娇懒懒',
    '撒野爱你超大字库',
    '收藏的诗篇',
    '时光和你都很美',
    '方正欧蝶正楷',
    '璀璨星辰',
    '银河最温柔',
    '山河脑海唯有你',
    '对你何止心动',
    '国标宋体-超大字符集',
    '方正黑体',
    '方正书宋',
    '方正楷体',
    '方正隶属',
    '方正仿宋',
    '方正兰亭黑',
    '方正等线',
    '小米体',
    '仓耳云黑',
    'Arial',
    '微软雅黑',
    '思源黑体',
    '思源宋体',
    '腾讯体 W3',
    '腾讯体 W7',
    'Helvetica',
    'Museo slab',
    'Neo Sans',
    'Gilroy std',
    'FF DIN',
    'Avenir Next',
    'Agecy FB',
];
